import { NsPaletteColor } from "./ns-eds-types";

export const nsPaletteColors = [
  "yellow50",
  "yellow100",
  "yellow200",
  "yellow300",
  "yellow400",
  "yellow500",
  "yellow600",
  "yellow700",
  "yellow800",
  "yellow900",
  "blue50",
  "blue100",
  "blue200",
  "blue300",
  "blue400",
  "blue500",
  "blue600",
  "blue700",
  "blue800",
  "blue900",
  "teal50",
  "teal100",
  "teal200",
  "teal300",
  "teal400",
  "teal500",
  "teal600",
  "teal700",
  "teal800",
  "teal900",
  "green50",
  "green100",
  "green200",
  "green300",
  "green400",
  "green500",
  "green600",
  "green700",
  "green800",
  "green900",
  "red50",
  "red100",
  "red200",
  "red300",
  "red400",
  "red500",
  "red600",
  "red700",
  "red800",
  "red900",
  "orange50",
  "orange100",
  "orange200",
  "orange300",
  "orange400",
  "orange500",
  "orange600",
  "orange700",
  "orange800",
  "orange900",
  "purple50",
  "purple100",
  "purple200",
  "purple300",
  "purple400",
  "purple500",
  "purple600",
  "purple700",
  "purple800",
  "purple900",
  "pink50",
  "pink100",
  "pink200",
  "pink300",
  "pink400",
  "pink500",
  "pink600",
  "pink700",
  "pink800",
  "pink900",
  "gray50",
  "gray75",
  "gray100",
  "gray200",
  "gray300",
  "gray400",
  "gray500",
  "gray600",
  "gray700",
  "gray800",
  "gray900",
  "gray950",
  "black",
  "white",
  "transparent",
  "alphaBlack50",
  "alphaBlack75",
  "alphaBlack100",
  "alphaBlack200",
  "alphaBlack300",
  "alphaBlack400",
  "alphaBlack500",
  "alphaBlack600",
  "alphaBlack700",
  "alphaBlack800",
  "alphaBlack900",
  "alphaWhite50",
  "alphaWhite75",
  "alphaWhite100",
  "alphaWhite200",
  "alphaWhite300",
  "alphaWhite400",
  "alphaWhite500",
  "alphaWhite600",
  "alphaWhite700",
  "alphaWhite800",
  "alphaWhite900",
] as const;

export function isNsPaletteColor(color: string): color is NsPaletteColor {
  return nsPaletteColors.includes(color as NsPaletteColor);
}
